import { InnerNavigatorOption } from 'components/ui/InnerNavigator';
import { usePermissions } from 'hooks';

export function InnerOptions() {
  const { checkUserPermission } = usePermissions();
  const options: InnerNavigatorOption[] = [
    {
      title: 'Veiculos',
      route: '/settings/hub-vehicles',
      hasPermission: checkUserPermission('accessConfigurator'),
    },
    {
      title: 'Novo Veiculo',
      route: '/settings/hub-vehicles/new',
      hasPermission: checkUserPermission('accessConfigurator'),
    },
  ];

  return { options };
}
